import $ from 'jquery';
import whenDomReady from 'when-dom-ready';
import ViewProduct from 'Views/view-product';

whenDomReady(() => {
    new ViewProduct({el: $('#MainContent')});
});
